import { useIntl } from "react-intl";

import PartyHorn from "~/hec/assets/icons/party-horn";
import { BodyCopy } from "~/hec/components/ui/body-copy";
import { Heading } from "~/hec/components/ui/heading";

import messages from "./messages";

/**
 * SFCC-11505 — port of composable `passedQuizBlock.jsx`. The success state shown
 * in the quiz accordion panel after a passing submission.
 */
const PassedQuizBlock = ({ moduleTitle }: { moduleTitle: string }) => {
  const intl = useIntl();
  return (
    <div
      className="flex flex-col items-center rounded-md bg-active/30 py-[3.25rem]"
      data-testid="passedQuizBlock"
    >
      <PartyHorn />
      <Heading
        tag="h4"
        variant="h4"
        className="mb-2 mt-5 text-emphasis"
        data-testid="passedQuizBlock-Heading"
      >
        {intl.formatMessage(messages.quizPassedHeading)}
      </Heading>
      <BodyCopy
        size="large"
        className="text-emphasis"
        data-testid="passedQuizBlock-BodyCopy"
      >
        {intl.formatMessage(messages.quizPassedBody, { moduleTitle })}
      </BodyCopy>
    </div>
  );
};

export default PassedQuizBlock;
